const message = {
  uploading: "Uploading",
  documentName: "Document name",
  editDocumentName: "Edit document name",
};

export default message;
